export const typography = (defaultTheme) => {
    defaultTheme.typography.button.textTransform = 'none'
    return defaultTheme;
}